import React from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import { Inject, PieSeries, AccumulationChartComponent, AccumulationSeriesCollectionDirective, AccumulationSeriesDirective, AccumulationLegend, AccumulationTooltip, AccumulationDataLabel } from '@syncfusion/ej2-react-charts';
import { FacilityIssueTypeBreakdownView } from '../../../../services/ReportingService';

interface TicketsByIssueTypeChartProps {
  issueTypeData: FacilityIssueTypeBreakdownView[];
}

const TicketsByIssueTypeChart: React.FC<TicketsByIssueTypeChartProps> = ({ issueTypeData }) => {
  return (
    <Card sx={{ border: '1px solid #e2e8f0', flex: 1 }}>
      <CardContent>
        <Typography variant="subtitle1" sx={{ fontWeight: 600, color: '#1e293b', mb: 2 }}>
          Tickets by Issue Type
        </Typography>
        {issueTypeData.length > 0 ? (
          <AccumulationChartComponent
            id="tickets-by-issue-type"
            tooltip={{ enable: true }}
            height="300px"
          >
            <Inject services={[PieSeries, AccumulationLegend, AccumulationTooltip, AccumulationDataLabel]} />
            <AccumulationSeriesCollectionDirective>
              <AccumulationSeriesDirective
                dataSource={issueTypeData}
                xName="issueType"
                yName="ticketCount"
                type="Pie"
                dataLabel={{ visible: true, position: 'Outside', name: 'issueType' }}
              />
            </AccumulationSeriesCollectionDirective>
          </AccumulationChartComponent>
        ) : (
          <Box sx={{ height: 300, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Typography variant="body2" color="#64748b">
              No data available
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

export default TicketsByIssueTypeChart;
